/**
 * Crunch Design System — Tag
 *
 * Figma component:
 *   tag (key: 88d16dfe0126f6f4d956dae1009e742057f25a0f)
 *
 * Usage:
 *   <Tag type="success" icon={<FontAwesomeIcon icon={faCheck} />}>Approved</Tag>
 *   <Tag type="danger" outlined>Overdue</Tag>
 */
import * as React from 'react';

export function Tag({
    type = "secondary",
    outlined = false,
    icon,
    children,
    className,
    ...rest
}: {
    type?: "brand" | "secondary" | "important" | "danger" | "success" | "warning" | "info";
    outlined?: boolean;
    icon?: React.ReactNode;
    children?: React.ReactNode;
    className?: string;
    [key: string]: any;
}) {
    const cls = [
        "cr-tag",
        `cr-tag--${type}`,
        outlined && "cr-tag--outlined",
        className,
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <span className={cls} {...rest}>
            {icon && <span className="cr-tag__icon">{icon}</span>}
            {children}
        </span>
    );
}
